import { ReactNode } from "react";
import classNames from "classnames";

import styles from "./BillingLabelValue.module.scss";

export enum BillingLabelValueSize {
  Medium = "medium",
  Large = "large",
}

interface BillingLabelValueProps {
  value?: ReactNode;
  label?: string;
  valueSize?: BillingLabelValueSize;
  valueColor?: string;
  customLabel?: ReactNode;
}

export const BillingLabelValue = ({
  value,
  label,
  valueSize = BillingLabelValueSize.Medium,
  valueColor,
  customLabel,
}: BillingLabelValueProps) => {
  return (
    <div className={styles.container}>
      <p className={styles.label}>
        {label}
        {customLabel}
      </p>
      {value !== undefined && (
        <p className={classNames(styles.value, styles[valueSize])} style={{ color: valueColor }}>
          {value}
        </p>
      )}
    </div>
  );
};
